import { translate } from '../../../Internationalization';
import CopyAgentWidgetScript from './CopyAgentWidgetScript/CopyAgentWidgetScript';
import flags from '../../../../shared/Flags';
import GenericValuationTable from './LeadsTable/Generic/GenericValuationTable';
import images from '../../../../config/local/images';
import LeadsTable from './LeadsTable';
import Loading from '../../../../shared/Loading';
import NoContent from '../../../../shared/NoContent';
import React from 'react';
import useGetAgentsPersonalData from '../../../../Hooks/Agent/Getters/useGetAgentsPersonalData/useGetAgentsPersonalData';
import useIsFeatureActive from '../../../../Hooks/Shared/useIsFeatureActive/useIsFeatureActive';
import useIsGated from '../../../../Hooks/Shared/useIsGated/useIsGated';
import ValuationsContent from './LeadsTable/ValuationsContent';
import WidgetHeader from '../Header/WidgetHeader';

const header = (
	<WidgetHeader
		description={translate(
			'agent.pages.widgets.lead_generation.description'
		)}
		illustration={images.homeowners.documents.header}
		title={translate('agent.pages.widgets.lead_generation.cta')}
	/>
);

export default function Valuation() {
	const featureActive = useIsFeatureActive(flags.agent.showValuationWidget);
	const { isGated, isGettingData } = useIsGated(flags.agent.avmLeadGenWidget);
	const { data } = useGetAgentsPersonalData();
	const hasAvmAccess = data?.groups.some(group => group.avmLeadGenWidget) ?? false; // prettier-ignore

	if (isGettingData) {
		return (
			<React.Fragment>
				{header}
				<ValuationsContent isGated={true}>
					<Loading />
				</ValuationsContent>
			</React.Fragment>
		);
	}

	if (!featureActive) {
		return (
			<React.Fragment>
				{header}
				<ValuationsContent isGated={true}>
					<NoContent
						message={translate('global.feature_unavailable')}
					/>
				</ValuationsContent>
			</React.Fragment>
		);
	}

	if (isGated && !hasAvmAccess) {
		return (
			<React.Fragment>
				{header}
				<ValuationsContent isGated={true}>
					<GenericValuationTable />
				</ValuationsContent>
			</React.Fragment>
		);
	}

	return (
		<React.Fragment>
			{header}
			<LeadsTable />

			<CopyAgentWidgetScript />
		</React.Fragment>
	);
}
